import React, { useEffect } from 'react'

const UsersApprove = () => {

    return(<p>Content</p>);
}

export default UsersApprove